import _ from 'lodash'
import {createContext, FC, useContext, useState} from 'react'

type DrawerContextType = {
  activeDrawerId: string | null
  openDrawer: (id: string) => void
  closeDrawer: () => void
}

const DrawerContext = createContext<DrawerContextType>({
  activeDrawerId: null,
  openDrawer: _.identity,
  closeDrawer: _.identity,
})

export const DrawerProvider: FC<React.PropsWithChildren> = ({children}) => {
  const [activeDrawerId, setActiveDrawerId] = useState<string | null>(null)

  const openDrawer = (id: string) => setActiveDrawerId(id)
  const closeDrawer = () => setActiveDrawerId(null)

  return (
    <DrawerContext.Provider value={{activeDrawerId, openDrawer, closeDrawer}}>
      {children}
    </DrawerContext.Provider>
  )
}

export const useDrawer = (drawerId: string) => {
  const {activeDrawerId, openDrawer, closeDrawer} = useContext(DrawerContext)

  const isActive = activeDrawerId === drawerId

  return {
    isDrawerActive: isActive,
    openDrawer: () => openDrawer(drawerId),
    closeDrawer,
  }
}
